import { useEvalFeatureFlagsQuery } from "src/store/features/api/notabene";
import { useAuth } from "src/providers/AuthProvider";

/**
 * Lightweight client hook around `GET /feature-flags/eval?keys=...`.
 *
 * Returns `{ enabled, isLoading, isError }`. The hook is keyed on a single
 * flag, but we batch several flag-evaluation calls per page using RTK
 * Query's request deduplication — each unique `[key]` is one round-trip.
 *
 * Skipped entirely while `isAuthenticated` is false — see `useTrEnabled`
 * for the rationale (refetchOnFocus + AuthnMiddleware 401).
 *
 * Usage:
 *   const { enabled } = useFeatureFlag("TR_THIRD_PARTY_BLOCK");
 *   if (enabled) { ... }
 */
export function useFeatureFlag(key: string): {
  enabled: boolean;
  isLoading: boolean;
  isError: boolean;
} {
  const { isAuthenticated } = useAuth();
  const { data, isLoading, isError } = useEvalFeatureFlagsQuery([key], {
    skip: !isAuthenticated,
  });
  return {
    enabled: Boolean(data?.[key]),
    isLoading,
    isError,
  };
}
